import React from 'react'

export const DATE = 'DATE'
export const NAME = 'NAME'
export const ROLE = 'ROLE'
export const STATUS = 'STATUS'
